import React from "react";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Menu from "@mui/material/Menu";
import { Viewer } from "components/auth/types";
import Navigation from "../navigation";

const HamburgerMenu: React.FC<{viewer?: Viewer | null}> = ({ viewer }) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) =>
    setAnchorEl(event.currentTarget);

  const handleClose = () => setAnchorEl(null);

  return (
    <>
      <IconButton
        sx={{ color: "white" }}
        size="small"
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleClick}>
        <MenuIcon />
      </IconButton>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <Navigation viewer={viewer} mobile handleClose={handleClose}/>
      </Menu>
    </>
  );
};

export default HamburgerMenu;
